import * as A from '../actions/helpActions';

const init = {
    showHelpMenu: false,
    activeKey: '',
    showFaqModal: false
}

export default (state=init, action) => {
    switch(action.type) {
        case A.SET_HELP_MENU_ACTIVE_KEY: return {...state, activeKey: action.payload };
        case A.TOGGLE_HELP_MENU: return {...state, showHelpMenu: !state.showHelpMenu };
        case A.TOGGLE_HELP_FAQ_MODAL: return {...state, showFaqModal: !state.showFaqModal };
        default: return {...state};
    }
}
